import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import NoResultsFrame1 from '../../images/no-results-frame1.png';
import NoResultsFrame2 from '../../images/no-results-frame2.png';
import NoResultsFrame3 from '../../images/no-results-frame3.png';

export const NoFilterResults = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center mt-6">
      <div className="relative w-[160px] h-[160px] rounded-full bg-[#9cd7f2] overflow-hidden mb-6">
        <img
          className="absolute w-[120px] h-[110px] left-[42px] top-[18px]"
          src={NoResultsFrame1}
          alt={t('analytics.no-results')}
        />
        <img
          className="absolute w-[65px] h-[38px] left-[56px] top-[122px]"
          src={NoResultsFrame2}
          alt={t('analytics.no-results')}
        />
        <img
          className="absolute w-[62px] h-[87px] left-[-3px] top-[61px]"
          src={NoResultsFrame3}
          alt={t('analytics.no-results')}
        />
      </div>
      <div className="font-sans font-medium text-[17px] leading-[25px] ">
        {' '}
        {t('analytics.nothing-found')}
      </div>
      <div className="text-xs font-sans font-normal leading-5 text-neutral-b1">
        {t('analytics.search-again')}
      </div>
    </div>
  );
};
